export default __webpack_public_path__ + "static/Mont-RegularItalic-399b62e30e75699fb77d86f86cd376b7.otf";